import cx from 'classnames'
import type React from 'react'

import css from './Loading.module.scss'

type Classnames = {
  container?: string
  variant?: string
}

type Props = {
  classnames?: Classnames
  color?: 'default' | 'gray' | 'coral'
  type?: 'small' | 'smallx2' | 'medium' | 'xsmall'
  variant?: 'two' | 'tree'
}

const Loading: React.FC<Props & React.HTMLProps<HTMLDivElement>> = ({
  classnames,
  color = 'default',
  type = 'small',
  variant = 'tree',
}) => {
  const cn: Classnames = {
    container: cx(css.container, css[color], css[type], classnames?.container),
    variant: cx(css.container, css[variant]),
  }

  return (
    <div className={cn.container}>
      <span />
      <span />
      {variant === 'tree' && <span />}
    </div>
  )
}

export default Loading
